import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/OrderCta.css";

interface OrderCtaProps {
  variant: "home" | "location" | "menu";
}

const OrderCta: React.FC<OrderCtaProps> = ({ variant }) => {
  const { t } = useTranslation();

  const getClasses = (): {
    container: string;
    link: string;
    divider: string;
  } => {
    switch (variant) {
      case "home":
        return {
          container: "hero-cta",
          link: "cta-link",
          divider: "cta-divider",
        };
      case "location":
        return {
          container: "location-hero-cta",
          link: "hero-cta-link",
          divider: "hero-cta-divider",
        };
      case "menu":
        return {
          container: "menu-hero-cta",
          link: "menu-cta-link",
          divider: "menu-cta-divider",
        };
    }
  };

  const classes = getClasses();

  return (
    <div className={classes.container}>
      <Link to="/order" className={classes.link}>
        {t("common.orderNow")}
      </Link>
      <span className={classes.divider}>|</span>
      <Link to="/reservations" className={classes.link}>
        {t("common.reservations")}
      </Link>
    </div>
  );
};

export default OrderCta;
